<template>
  <div>
    <div class="anlicell"  @click="gotolabeldetails">
      <div class="showgotobox" @click.stop="gotoenterweb(categorydata.url)">
          <div class="entericon"><img :src="fawicon"/></div>
          <div class="enterweb">进入网站</div>
      </div>  
      <span>
        <img :src="anlismlogo" />
        <i>{{categorydata.score}}</i>
      </span>
      <dl>
        <dt>
          <img :src="categorydata.icon" />
        </dt>
        <dd>
          <h5>{{categorydata.name}}</h5>
          <p>{{categorydata.describe}}</p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props:["categorydata"],
  data() {
    return {
      blogo01: require("@/assets/images/b-icon_001.jpg"),
      fawicon: require("@/assets/images/fwicon01.png"),
      blogo03: require("@/assets/images/b-icon_003.jpg"),
      blogo04: require("@/assets/images/b-icon_004.jpg"),
      blogo05: require("@/assets/images/b-icon_005.jpg"),
      anlismlogo: require("@/assets/images/alsmlogo.gif"),     
     
    };
  },
  
  methods:{
      gotolabeldetails(){
        this.$router.push({
            name:'labeldetails'
        })
      },
      gotoenterweb(url){
        let href = url;  
        window.open(href, "_blank");
      }
  }
};
</script>

<style lang="scss" scoped>
.anlicell {
   position: relative; height: 95px; width: 100%;
  span {
    position: absolute;
    right: 0;
    top: 0px;
   
    padding: 5px;
    i {
      float: left;
      padding-left: 5px;
      padding-right: 5px;
      color: #999;
    }
    img {
      float: left;
      margin-top: 2px;
    }
  }
  dl {
    padding-top: 25px;
    dt {
      float: left;
      width: 50px;
      padding-left: 15px;
      padding-top: 5px;
    }
    dd {
      padding-left: 55px;

      h5 {
        font-size: 15px;
        font-weight: normal;
        color: #333;
      }
      p {
        color: #999;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        /*-webkit-text-overflow:ellipsis;*/
        white-space: nowrap;
      }
    }
  }


  .showgotobox{
      position: absolute;opacity:0;transition:0.5s;
      width: 38%;
      height: 82px;right: 0; top:5px; z-index:6;
      background: linear-gradient(left, rgba(255, 255, 255,0.2), #fff);
      .entericon{
           float: right; padding-top: 18px; padding-right: 10px; margin-right: 10px;
      }
      .enterweb{ font-size:12px; clear: both; color: #999;float: right;margin-right: 10px;}
     
  }  


}

.anlicell:hover{
     box-shadow: 0 0 8px #ddd; height: 95px; width: 100%;
     .showgotobox{
         opacity: 1;
     }
}

</style>


// WEBPACK FOOTER //
// src/components/publish/webcell.vue